<template>
  <div>
    <a-modal
        :title="title"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel"
        :footer="null"
      >
      <div>
        <a-input
          v-model="keyword"
          @input="handleSearch"
          placeholder="搜索名称、地址、备注、描述"
          class="search_keyword"
        />
        <a-list bordered :dataSource="data">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            @click="handleItemClick(item)"
          >{{ item.text }}</a-list-item>
        </a-list>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    markerList: Array,
  },
  data() {
    return {
      title: '搜索标记',
      data: [],
      keyword: '',
    };
  },
  methods: {
    handleOk() {
      this.handleCancel();
    },
    handleCancel() {
      this.$emit('update:visible', false);
    },
    handleSearch(event) {
      const { value } = event.target;
      if (value) {
        this.data = [];
        const resultList = this.data;
        this.markerList.forEach((item, index) => {
          // 搜索名称
          if (item.name && item.name.indexOf(value) !== -1) {
            resultList.push({
              text: `名称：${item.name}`,
              value: index,
            });
          }

          // 搜索备注
          if (item.labelContent && item.labelContent.indexOf(value) !== -1) {
            resultList.push({
              text: `备注：${item.labelContent}`,
              value: index,
            });
          }

          // 搜索描述
          if (item.descContent && item.descContent.indexOf(value) !== -1) {
            resultList.push({
              text: `描述：${item.descContent}`,
              value: index,
            });
          }

          // 搜索地址
          if (item.address && item.address.indexOf(value) !== -1) {
            resultList.push({
              text: `地址：${item.address}`,
              value: index,
            });
          }
        });
      } else {
        this.data = [];
      }
    },
    handleItemClick(item) {
      const clickMarker = this.markerList[item.value];
      this.$emit('markerClick', clickMarker);
      this.handleCancel();
      this.keyword = '';
      this.data = [];
    },
  },
};
</script>

<style>
.search_keyword {
  display: block;
  margin-bottom: 20px;
}

* /deep/ .ant-list-item:hover {
  cursor: pointer;
  /* background-color: #e6f7ff; */
}
</style>
